































































































import moment from "moment/moment";
import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import { Prop, Watch } from "vue-property-decorator";
import DateObject from "@/shared/dateObject";
import MyTimeChooser from "@/components/timeChooser.vue";
import DateType from "@/shared/DateType";
import MobileMixin from "@/mixins/mobileMixin";

@Component({
  components: {
    MyTimeChooser,
  },
})
export default class DateChooserCentral extends mixins(MyMixin, MobileMixin) {
  @Prop({ default: false }) public isFavoris!: boolean;
  @Prop({ default: false }) public isDecadeAllowed!: boolean;
  @Prop({ default: new DateType() }) public dateType!: DateType;
  @Prop({ default: "vertical" }) public orientation!: string;
  @Prop({ default: true }) public showWeek!: boolean;
  @Prop({ default: false }) public showHours!: boolean;
  @Prop({ default: false }) public datesMultiples!: boolean;

  public today = moment();
  public dateVisibles: Array<DateObject> = [];
  public days = 0;

  public menu: boolean = false;
  public periode = 0;
  public typePeriode:
    | "s"
    | "day"
    | "hour"
    | "minute"
    | "month"
    | "second"
    | "year"
    | "m"
    | "h"
    | "d"
    | "w"
    | "M"
    | "y"
    | "years"
    | "months"
    | "week"
    | "weeks"
    | "days"
    | "hours"
    | "minutes"
    | "seconds" = "days";
  public periodesList: string[] = [];
  public avPer: string[] = [];
  public configPeriode: any = { days: 1 }; // days, months, weeks, years
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];
  public periodesAv = [
    { id: "J", title: "Aujourd'hui", p: 0 },
    { id: "J_PRECEDENT", title: "Hier", p: 0 },
    { id: "AVANT_HIER", title: "AvantHier", p: 0 },
    { id: "LUN_A_DIM", title: "SemaineEnCours", p: 1 },
    { id: "SEMAINE_PRECEDENTE", title: "SemainePrecedente", p: 1 },
    { id: "MOIS", title: "MoisEnCours", p: 2 },
    { id: "MOIS_PRECEDENT", title: "MoisPrecedent", p: 2 },
    { id: "SIX_DERNIERS_MOIS", title: "SIX_DERNIERS_MOIS", p: 2 },
    { id: "ANNEE", title: "AnneeEnCours", p: 3 },
    { id: "ANNEE_PRECEDENTE", title: "AnneePrecedente", p: 3 },
    { id: "MOINS_365", title: "MOINS_365", p: 3 },
    { id: "PERSO", title: "PeriodePersonnalisee", p: 4 },
  ];

  /**
   * methode permettant d'afficher le nombre de type de periode disponibles
   */
  public getMaxPeriodes() {
    if (this.client === "BUFFALO" && this.isDecadeAllowed) {
      return 4;
    } else {
      return 3;
    }
    // return 3;
  }

  public isToday(date: DateObject) {
    let hide = -1;
    if (this.periode !== 0) {
      return -1;
    }
    const madate = date.timestamp ? moment(date.timestamp) : moment();
    const hier = moment().subtract(1, "days").startOf("day");
    if (madate.isSame(moment(), "d")) {
      hide = 1;
    }
    if (madate.isSame(hier, "d")) {
      hide = 2;
    }
    return hide;
  }
  /*
   * methode de filtre des periodes à afficher en mode favoris
   */
  public filteredPeriodes() {
    // console.log(this.periodesAv)
    const result = this.periodesAv.filter(
      (periode: any) => periode.p === this.dateType.periode
    );
    result.pop();
    // this.$forceUpdate();
    return result;
  }
  /**
   * methode de verification que la date affichée est celle de la fin de la période
   */
  public isDateFin(date: Date) {
    switch (this.periode) {
      case 0:
        return moment(date).isSame(this.dateType.dateFin, "day");
      case 1:
        const same = moment(date).isSame(this.dateType.dateFin, "isoWeek");
        return same;
      case 2:
        return moment(date).isSame(this.dateType.dateFin, "month");
      case 3:
        return moment(date).isSame(this.dateType.dateFin, "year");
      case 4:
        return moment(date).isSame(this.dateType.dateFin, "day");
    }
    return moment(date).isSame(this.dateType.dateFin, "day");
  }
  /**
   * methode permettant d'afficher les dates dans le date carrousel
   */
  public selectVisibleDates(startDate: Date, start?: boolean) {
    for (let i = 0; i <= 15; i++) {
      let maDate;
      let dateObj;
      switch (this.periode) {
        case 0: {
          maDate = moment(startDate).subtract(i, "d").toDate();
          dateObj = this.formatDateDay(maDate);
          break;
        }
        case 1: {
          maDate = moment(startDate).subtract(i, "w").startOf("isoWeek");
          dateObj = this.formatDateWeek(maDate.toDate());
          break;
        }
        case 2: {
          maDate = moment(startDate).subtract(i, "month").startOf("month");
          dateObj = this.formatDateMonth(maDate.toDate());
          break;
        }
        case 3: {
          maDate = moment(startDate).subtract(i, "y").startOf("year");
          dateObj = this.formatDateYear(maDate.toDate());
          break;
        }
        case 4: {
          maDate = this.getMaDateDecade(startDate, i);
          dateObj = this.formatDateDecade(maDate);
          break;
        }
        default: {
          maDate = moment(startDate).subtract(i, "d").toDate();
          dateObj = this.formatDateDay(maDate);
          break;
        }
      }
      this.dateVisibles.push(dateObj);
    }
    this.dates[0] = this.dateVisibles[0].start.toISOString();
    this.dates[1] = this.dateVisibles[0].end.toISOString();

    if (!this.isFavoris) {
      this.updateDates();
    }
  }
  /**
   * methode de calcul de la translation à afficher au dateCarrousel en mode rapport
   */
  public getTranslate() {
    return `transform: translateX(${this.days * 20}%)`;
  }
  /**
   * methode de selection de la date via le carrousel en mode rapport
   */
  public selectDateFin(dateObj: DateObject) {
    this.dates[1] = dateObj.end.toISOString();
    this.dates[0] = dateObj.start.toISOString();
    this.updateDates();
    let yesterday;
    this.periode === 4
      ? (yesterday = moment(dateObj.end).subtract("d", 10))
      : (yesterday = moment(dateObj.end).subtract(this.configPeriode));
    let isSame;
    if (this.periode === 1) {
      isSame = this.today.isSame(yesterday, "w");
    } else {
      let p: "d" | "month" | "year" = "d";
      if (this.periode === 2) {
        p = "month";
      } else if (this.periode === 3) {
        p = "year";
      }
      isSame = moment(yesterday).isSame(this.today.toDate(), p);
    }
    // console.log("days", isSame, this.days, this.dateVisibles.length);
    this.days = 0;
    if (!isSame) {
      this.days = this.today.diff(yesterday, this.typePeriode) - 1;
      if (this.periode === 1) {
        this.days = Math.trunc(this.days / 7) - 1;
      }
      if (this.periode === 4) {
        const decade = this.formatDateDecade(new Date());
        this.days = moment(decade.start).diff(yesterday, this.typePeriode) - 12;
        this.days /= 10;
      }
      if (this.days < 0) {
        this.days = 0;
      }
      // console.log("days", this.days, this.dateVisibles.length);
      if (this.days >= this.dateVisibles.length - 4) {
        const startDate = moment(
          this.dateVisibles[this.dateVisibles.length - 1].timestamp
        ).subtract(1, "d");
        this.selectVisibleDates(startDate.toDate());
      }
    }
  }
  /**
   * méthode de traduction du label a afficher dans le slilder des periodes
   */
  public getPeriodeLabel() {
    switch (this.periode) {
      case 0:
        this.configPeriode = { days: 1 };
        this.typePeriode = "days";
        return this.$i18n.tc("jour").toString();
      case 1:
        this.configPeriode = { days: 7 };
        this.typePeriode = "days";
        return this.$i18n.tc("sem.").toString();
      case 2:
        this.configPeriode = { month: 1 };
        this.typePeriode = "months";
        return this.$i18n.tc("mois").toString();
      case 3:
        this.configPeriode = { year: 1 };
        this.typePeriode = "years";
        return this.$i18n.tc("annee").toString();
      case 4:
        this.configPeriode = { days: 11 };
        this.typePeriode = "days";
        return this.$i18n.tc("Decade").toString();
    }
  }
  /**
   * methode de maj de la periode
   */
  public updateP(evt: any) {
    // console.log(evt);
    if (!this.isFavoris) {
      this.days = 0;
      this.dateVisibles = [];
      this.selectVisibleDates(new Date());
    } else {
      const per = this.periodesAv.find((periode) => periode.p === this.periode);
      this.dateType.typePeriode = per ? per.id : "J";
      // console.log(this.dateType.typePeriode);
    }
    this.dateType.periode = this.periode;
    this.$forceUpdate();
    this.update();
  }
  public updatePe(evt: any) {
    this.periode = evt;
    this.getPeriodeLabel();
    if (!this.isFavoris) {
      this.days = 0;
      this.dateVisibles = [];
      this.selectVisibleDates(new Date());
    } else {
      const per = this.periodesAv.find((periode) => periode.p === this.periode);
      this.dateType.typePeriode = per ? per.id : "J";
      // console.log(this.dateType.typePeriode);
    }
    this.dateType.periode = this.periode;
    this.$forceUpdate();
    this.update();
  }
  public closeDatePicker(show: boolean) {
    if (!show && this.dates[1] === undefined && !this.dateType.datesMultiples) {
      this.dates[1] = this.dates[0];
      this.updateDates();
    }
  }
  /**
   * méthode de mise à jour dans le rapport de la date de fin et de la date de début en fonction de la période selectionnée
   */
  public updateDates() {
    // console.log("updatedates", this.dateType);
    if (!this.dateType.datesMultiples) {
      if (moment(this.dates[0]).isAfter(moment(this.dates[1]))) {
        this.dateType.setDateDebut(new Date(this.dates[1]));
        this.dateType.setDateFin(new Date(this.dates[0]));
      } else {
        this.dateType.setDateDebut(new Date(this.dates[0]));
        this.dateType.setDateFin(new Date(this.dates[1]));
      }
    } else {
      const listOfDates: Date[] = [];
      for (const index in Object.keys(this.dates)) {
        if (this.dates.hasOwnProperty(index)) {
          listOfDates.push(new Date(this.dates[index]));
        }
      }
      this.dateType.setDates(listOfDates);
    }
    this.update();
  }
  /**
   * methode permettant d'appliquer un style à la periode selectionnée
   */
  public isSelectedPeriode(periode: any) {
    return this.dateType.typePeriode === periode.id;
  }
  /**
   * selection de la période pour un rapport favoris
   */
  public selectRapportPeriode(periode: any) {
    this.dateType.typePeriode = periode.id;
    this.$set(this.dateType, "typePeriode", periode.id);
    // console.log("select periode", periode, this.dateType.typePeriode);
    this.update();
    this.$forceUpdate();
  }
  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public getDatesStr() {
    if (!this.dateType.datesMultiples && this.dates.length === 2) {
      let deb = moment(this.dates[0]).format("DD/MM/YYYY");
      let fin = moment(this.dates[1]).format("DD/MM/YYYY");
      if (moment(this.dates[0]).isAfter(moment(this.dates[1]))) {
        const temp = deb;
        deb = fin;
        fin = temp;
      }
      return `${this.$i18n.tc("from").toString()} ${deb} ${this.$i18n
        .tc("to")
        .toString()} ${fin}`;
    } else if (this.dateType.datesMultiples) {
      let result = "";
      for (const index in this.dates) {
        if (this.dates.hasOwnProperty(index)) {
          result += moment(this.dates[index]).format("DD/MM/YYYY") + ";";
        }
      }
      return result;
    }
  }
  /*
   * mise a jour du rapport : evenement lancé
   */
  public update() {
    this.$emit("update", this.dateType);
  }
  public isDateVisible(index: any) {
      // Vérifie si l'élément est dans la plage visible
      return index >= 0 && index < 0 + 4;
    }
  // mounted
  public mounted() {
    this.dates = [
      this.dateType.dateDebut.toISOString().substr(0, 10),
      this.dateType.dateFin.toISOString().substr(0, 10),
    ];
    const today = new Date();
    const locale = this.$i18n.locale;
    this.dateVisibles = [];
    // moment.locale(locale);
    this.avPer = [
      this.$t("jour").toString(),
      this.$t("sem.").toString(),
      this.$t("mois").toString(),
      this.$t("annee").toString(),
      this.$t("Decade").toString(),
      "",
    ];
    this.periode = this.dateType.periode;
    if (!this.isFavoris) {
      if (!moment(this.dateType.dateFin).isSame(this.today, "day")) {
        const startDate = this.dateType.dateDebut;
        let maDate;
        let dateObj;
        this.selectVisibleDates(today);
        switch (this.periode) {
          case 0:
            maDate = moment(startDate).toDate();
            dateObj = this.formatDateDay(maDate);
            break;
          case 1:
            maDate = moment(startDate).startOf("isoWeek");
            dateObj = this.formatDateWeek(maDate.toDate());
            break;
          case 2:
            maDate = moment(startDate).startOf("month");
            dateObj = this.formatDateMonth(maDate.toDate());
            break;
          case 3:
            maDate = moment(startDate).startOf("year");
            dateObj = this.formatDateYear(maDate.toDate());
            break;
          case 4:
            maDate = moment(startDate);
            dateObj = this.formatDateDecade(maDate.toDate());
            break;
          default:
            maDate = moment(startDate).toDate();
            dateObj = this.formatDateDay(maDate);
            break;
        }
        this.selectDateFin(dateObj);
      } else {
        this.selectVisibleDates(this.dateType.dateDebut);
      }
    }
    this.periodesList = this.avPer.slice(0, this.getMaxPeriodes() + 1);
  }

  @Watch("dates", { immediate: true })
  public onPropertyChanged(value: any, oldValue: any) {
    if (oldValue !== undefined && !this.isFavoris) {
      this.updateDates();
    }
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }
}
